import React, { useState, useRef } from "react";
import AboutBannerImage2 from "../../src/assets/images/Learn.jpg.jpeg";
import CustomLine from "./CustomLine";
import AppoinmentModal from "./AppoinmnetModal";
import { FaMedal } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Avatar1 from "../../src/assets/images/1.jpg";
import Avatar2 from "../../src/assets/images/2.jpg";
import Avatar3 from "../../src/assets/images/3.jpg";
import Avatar4 from "../../src/assets/images/4.jpg";

const CoursesBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const stickyButtonRef = useRef(null);
    const navigate = useNavigate();

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleJoinAcademy = () => {
        navigate('/register');
    };

   const handleExploreCourses = () => {
    navigate('/all-courses');
};

    return (
        <div className="custom-science pt-80 ">
            <div className="xl-screen-padding flex gap-10 flex-col md:flex-row w-full custom-padding">
                <div className="w-full md:w-1/2 flex flex-col justify-center aboutmain">
                    <h2 className="custom-padding-bottom text-lg sm:text-xl md:text-xl lg:text-4xl custom-line-height font-semibold text-black leading-tight client-text">
                        Learn, Practice,
                        <br />
                        <span className="text-[#6BCB3D]">Lead</span>
                    </h2>
                    <p className="text-[#939a9e] mb-6 text-p">
                        An advanced digital learning ecosystem designed for individuals who aspire to build meaningful, future-ready careers in clinical nutrition and evidence-based practice.
                    </p>
                    <div className="flex flex-row gap-4 items-center mt-6 flex-wrap">
                        {/* Modified Explore Courses button - now scrolls to featured courses */}
                        <button
                            onClick={handleExploreCourses}
                            className="bg-[#6BCB3D] hover:bg-[#5bb532] text-white font-semibold px-6 py-2 sm:px-8 sm:py-3 rounded-xl transition-all duration-300"
                        >
                            Explore Courses
                        </button>
                        <button
                            className="bg-[#7C517E] hover:bg-[#6a456c] text-white font-semibold px-6 py-2 sm:px-8 sm:py-3 rounded-xl transition-all duration-300"
                            onClick={handleJoinAcademy}
                        >
                            Join the Academy
                        </button>
                        <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
                    </div>
                    <div className="flex items-center gap-3 mt-8">
                        <div className="flex -space-x-2">
                            {/* Replace divs with img tags */}
                            <img
                                src={Avatar1}
                                alt="Student 1"
                                className="w-8 h-8 rounded-full border-2 border-white object-cover"
                            />
                            <img
                                src={Avatar2}
                                alt="Student 2"
                                className="w-8 h-8 rounded-full border-2 border-white object-cover"
                            />
                            <img
                                src={Avatar3}
                                alt="Student 3"
                                className="w-8 h-8 rounded-full border-2 border-white object-cover"
                            />
                            <img
                                src={Avatar4}
                                alt="Student 3"
                                className="w-8 h-8 rounded-full border-2 border-white object-cover"
                            />
                        </div>
                        <div>
                            <p className="text-sm font-semibold text-gray-700">
                                Trusted by 10k Learners
                            </p>
                            <p className="text-xs text-gray-500">
                                Join a Global Community of Curious Minds
                            </p>
                        </div>
                    </div>
                </div>

                <div className="w-full md:w-1/2 flex flex-col items-center justify-center py-8">
                    <div className="relative rounded-lg overflow-visible w-full max-w-full mx-auto">
                        <div className="aspect-w-1 aspect-h-1">
                            <img
                                src={AboutBannerImage2}
                                alt="Personalized roadmap"
                                className="w-full h-full object-cover lg:w-full lg:h-full"
                            />
                        </div>
                        {/* Box positioned outside the image on the left */}
                        <div className="absolute -bottom-4 -left-6 md:-left-30 bg-white px-4 py-3 flex items-center gap-3 font-lato shadow-md rounded-md z-10">
                            <div className="w-8 h-8 flex items-center justify-center">
                                <FaMedal className="w-5 h-5 text-green-600" />
                            </div>
                            <div>
                                <p className="text-sm font-black text-gray-800">
                                    #1 Rated
                                </p>
                                <p className="text-xs text-gray-500">
                                    Nutrition Academy
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative">
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>
                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>

            <div className="bg-[#1f2d3d] py-16 px-6 mt-10">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center mx-auto">
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl lg:text-4xl font-bold mb-2">50+</h2>
                        <p className="text-gray-300 text-xs md:text-sm lg:text-base tracking-wide uppercase font-bold">
                            Expert-led Courses
                        </p>
                    </div>
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl lg:text-4xl font-bold mb-2">25+</h2>
                        <p className="text-gray-300 text-xs md:text-sm lg:text-base tracking-wide uppercase font-bold">
                            Certified Instructors
                        </p>
                    </div>
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl lg:text-4xl font-bold mb-2">100%</h2>
                        <p className="text-gray-300 text-xs md:text-sm lg:text-base tracking-wide uppercase font-bold">
                            Online & Self-Paced
                        </p>
                    </div>
                    <div>
                        <h2 className="text-[#6BCB3D] text-2xl md:text-3xl lg:text-4xl font-bold mb-2">10k+</h2>
                        <p className="text-gray-300 text-xs md:text-sm lg:text-base tracking-wide uppercase font-bold">
                            Certificates Issued
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoursesBanner;